/** biome-ignore-all lint/style/useNamingConvention: analytics field names are snake_case */
export type UserState = 'LoggedIn' | 'LoggedOut';
export type UserType = 'Subscribed' | 'Registered' | 'FortuneUser';

export type UserClassification = {
  user_known: boolean;
  user_type: UserType | null;
  user_state: UserState | null;
  piano_id: string | null;
};

export const UNKNOWN_USER_CLASSIFICATION: UserClassification = {
  piano_id: null,
  user_known: false,
  user_state: null,
  user_type: null,
};

export type CookieGetter = (name: string) => string | undefined;

export type JwtDecoder = <T = unknown>(token: string) => T;
